import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        // position: 'relative',
        flex: 1,

        // overflow: 'auto',
        height: '100%',
        background: 'white'
        // padding: '24px'
    },
    backWrapper: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& img': {
            margin: '0 5px'
        }
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: 50,
        position: 'sticky',
        top: '0px',
        background: 'white',
        zIndex: 100,
        borderRadius: '10px'
    },
    footer: {
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        padding: '10px 23px',
        position: 'absolute',
        bottom: 0,
        left: '0',
        right: '0'
    },
    button: {
        height: 40,
        borderRadius: '100px !important',
        margin: 10,
        alignSelf: 'flex-end',
        fontSize: '0.9rem',
        boxShadow: 'unset'
    },

    confirmButtonsContainer: ({ isDataChanged }) => ({
        transition: '0.5s ease all',
        position: 'relative',
        top: isDataChanged ? 0 : 50,
        pointerEvents: isDataChanged ? undefined : 'none',
        opacity: isDataChanged ? 1 : 0,
        [theme.breakpoints.down(1025)]: {
            top: 0
        }
    }),
    cancelBtn: {
        borderRadius: '100px !important',
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        fontSize: '0.9rem',
        background: 'white'
    },
    imageList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: 1,
        overflow: 'auto',
        direction: 'rtl',
        position: 'relative',
        // paddingBottom: 50 --> only chrome and safari,
        // to add a padding bottom to list --> all browsers
        '&:after': {
            content: '" "',
            paddingBottom: '50px'
        },
        marginBottom: 10
    },
    imageContainer: {
        alignSelf: 'center',
        padding: '12px 0',
        [theme.breakpoints.down(1025)]: {
            padding: '12px 24px'
        }
    },
    image: {
        // marginBottom: 20
    },
    calender: {
        width: '250px',
        fontFamily: 'inherit',
        [theme.breakpoints.down(1025)]: {
            width: '200px'
        }
    },
    onEmptyComponent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        flex: 1,
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        margin: 'auto',
        width: '250px',
        height: '100px'
    },
    arrowLeft: {
        transform: 'rotateZ(180deg)'
    },
    headerContent: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    },
    dateContainer: {
        display: 'flex',
        // flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
        alignSelf: 'center',
        marginRight: 30,
        [theme.breakpoints.down(1025)]: {
            marginRight: 0
        }
    },
    datePickerContainer: {
        position: 'absolute',
        opacity: 0,
        background: 'red',
        '& > div:nth-of-type(1)': {
            width: 'unset',
            padding: 'unset'
        }
    },
    dateTitle: { width: 50, textAlign: 'center', userSelect: 'none', cursor: 'pointer' },
    dateValue: { width: 90, textAlign: 'center', userSelect: 'none', cursor: 'pointer' }
}));
